import { render, staticRenderFns } from "./EmailVerificationModal.vue?vue&type=template&id=e7a2dd8e&"
import script from "./EmailVerificationModal.vue?vue&type=script&lang=js&"
export * from "./EmailVerificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports